import { gql, useQuery } from "@apollo/client";
import { CustomInterventionItem } from "../../types";

interface InterventionsQueryResponse {
  customInterventions: CustomInterventionItem[];
}

const query = gql`
  query interventions($filter: InterventionFilter!) {
    customInterventions: interventions(filter: $filter) {
      id
      name
      description
      draft
      archived
      visibility
      deliveryMethod
      steps {
        id
        prompt
        type
        answers
        mediaType
        mediaUrl
      }
    }
  }
`;

export function useCustomInterventions(archived: boolean) {
  return useQuery<InterventionsQueryResponse>(query, {
    variables: { filter: { archived } },
  });
}
